import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CountryDomainService } from './country-domain.service';

/**
 * Blocks a route everywhere but a per-MR dynamic environment.
 *
 * Used by the environment-tools page: its jobs rebuild the search indices, re-index postal codes
 * and put the catalog reindex on a schedule — the bootstrap a fresh throwaway env needs, and a
 * mutation nobody should be one click away from on staging or production. The per-country
 * AdminBff would accept those triggers from any staff token, so the SPA gate is the only one.
 *
 * Mirrors `stagingOnlyGuard` with the opposite sense; redirects to the dashboard like
 * `countryFeatureGuard`, since there is no neighbouring page for the route to fall back to.
 */
export function dynEnvOnlyGuard(): CanActivateFn {
    return () => {
        const countryDomain = inject(CountryDomainService);
        const router = inject(Router);

        return countryDomain.isDynamicEnv() ? true : router.createUrlTree(['/']);
    };
}
